
import { Home } from "@/pages";
import { WhiteLabelHome } from "@/pages/WhiteLabelHome";
import { RouteProps } from "./types";

import DrugDetails from "@/pages/FindBestPrice/DrugDetails";
import PriceList from "@/pages/FindBestPrice/PriceList";
import PharmacyDetails from "@/pages/FindBestPrice/PharmacyDetails";

import * as AdvantageRoutes from "@/constants/routes";
import { PrivacyPolicy, TermsAndConditions } from "@/pages/Disclaimers";

export const advantageRoutes: Array<RouteProps> = [
  {
    path: AdvantageRoutes.Home,
    Component: Home,
    pageTitle: "Advantage Savings",
    analyticTag: "home-page",
  },
  {
    path: AdvantageRoutes.DrugDetails,
    Component: DrugDetails,
    pageTitle: "Drug Details",
    analyticTag: "findBestPrice-drug-details",
  },
  {
    path: AdvantageRoutes.PriceList,
    Component: PriceList,
    pageTitle: "Find Best Price - Price List",
    analyticTag: "findBestPrice-PriceList",
  },
  {
    path: AdvantageRoutes.PharmacyDetails,
    Component: PharmacyDetails,
    pageTitle: "Find Best Price - Pharmacy Details",
    analyticTag: "findBestPrice-PharmacyDetails",
  },
  {
    path: AdvantageRoutes.PrivacyPolicy,
    Component: PrivacyPolicy,
    pageTitle: "Privacy Policy",
    analyticTag: "privacyPolicy",
  },
  {
    path: AdvantageRoutes.TermsAndConditions,
    Component: TermsAndConditions,
    pageTitle: "Terms and Conditions",
    analyticTag: "termsAndConditions",
  },
  // with group number parameter
  {
    path: AdvantageRoutes.GroupNumber,
    Component: Home,
    pageTitle: "Advantage Savings",
    analyticTag: "home-page-with-group-number",
  },
];

export const advantageWhitelabelRoutes: Array<RouteProps> = [
  {
    path: AdvantageRoutes.Client,
    Component: WhiteLabelHome,
    pageTitle: "Advantage Savings",
    analyticTag: "home-page-with-group-number",
  },
  {
    path: AdvantageRoutes.WhiteLabelDrugDetails,
    Component: DrugDetails,
    pageTitle: "Drug Details",
    analyticTag: "findBestPrice-drug-details",
  },
  {
    path: AdvantageRoutes.WhiteLabelPriceList,
    Component: PriceList,
    pageTitle: "Find Best Price - Price List",
    analyticTag: "findBestPrice-PriceList",
  },
  {
    path: AdvantageRoutes.WhiteLabelPharmacyDetails,
    Component: PharmacyDetails,
    pageTitle: "Find Best Price - Pharmacy Details",
    analyticTag: "findBestPrice-PharmacyDetails",
  },
];
